<template>
  <div class="card" v-if="tmpType == 1">
    <div class="card-title">注意事项</div>
    <div class="card-content">
      1. 策划方案主题鲜明且统一贯穿。<br/>
      2. 方案的执行要给地方区域充分的准备时间。<br/>
      3. 活动场地应该要求当地区域提前进行实地勘察。<br/>
    </div>
  </div>
  <div v-else>
    <img style="width: 100%;height: 100%" :src="imgList[tmpType-2]" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    tmpType: String,
  },
  data() {
    return {
      imgList: [
        'https://img3.quanyou.com.cn/joyNew/group1/M00/1C/C2/rB8LrWUt_hiARzqPAADxTOiJpjY258.png',
        require('@/assets/images/styleTwo/attention.png'),
        require('@/assets/images/styleFour/hdgz.png'),
        require('@/assets/images/styleFive/zysx.png'),
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
.card
  box-sizing: border-box
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  // background: linear-gradient(#FF6B31 , #FF4A47);
  color #fff
  margin 15px
  &-title
    flex: none
    align-self: flex-start
    margin-bottom 10px
  &-content
    align-self: flex-start
    // margin 5px
    padding 5px
    line-height: 1.5
    border-radius: 8px
    background: rgba(255,184,146,0.5)
</style>